import autoTracker from './initializeAutoTracker';
import locale from './initializeLocale';
import templateString from './initializeTemplateString';
import userAccount from './initializeUserAccount';
import urlParameterTriggers from './url-parameter-triggers';
import outboundLinkClicker from './initializeOutboundLinkClicker';

export default {
  initializeApplication() {
    [
      autoTracker,
      locale,
      templateString,
      userAccount,
      urlParameterTriggers,
      outboundLinkClicker,
    ].forEach(initializer => initializer());
  },
};
